const LocalStorageItems = {
  token: localStorage.getItem('token'),
  user: JSON.parse(localStorage.getItem('user')),
};

export default LocalStorageItems;
